import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { SaveBookingPage } from './pages/SaveBooking.page';
import { VerifyPsicologistName } from './VerifyPsicologistName';
import { EditBooking } from './pages/EditBooking.page';

import { protectedRoutes } from './childrenRoutes';
import { ActionsPage } from './pages/ActionsPage';
import { CheckBooking } from './CheckBooking';

const router = createBrowserRouter([
  protectedRoutes,
  {
    path: '/agendar/:userUrl',
    element: <VerifyPsicologistName />,
  },
  {
    path: '/agendar/:userUrl/:agendaUrl',
    element: <VerifyPsicologistName />,
  },
  {
    path: '/booking/:bookingUrl',
    element: <CheckBooking />,
  },
  {
    path: '/booking/:bookingUrl/confirm',
    element: <CheckBooking />,
  },
  {
    path: '/actions/:token',
    element: <ActionsPage />,
  },
]);

export function Router() {
  return <RouterProvider router={router} />;
}
